import line from './line'
import rectangle from './rectangle'
import triangle from './triangle'
import ellipse from './ellipse'
import arrow from './arrow'
import withText from './with-text'
import path from './path'

export default {
  line,
  rectangle,
  triangle,
  ellipse,
  arrow,
  withText,
  path,

  types: {
    line: 'line',
    rectangle: 'rectangle',
    ellipse: 'ellipse',
    triangle: 'triangle',
    arrow: 'arrow'
  },

  isA: function (shape) {
    return line.isA(shape) ||
      rectangle.isA(shape) ||
      triangle.isA(shape) ||
      ellipse.isA(shape) ||
      arrow.isA(shape) ||
      withText.isA(shape) ||
      path.isA(shape)
  },

  new: function (type, pointer, fillColour, strokeColour, strokeWidth) {
    switch (type) {
      case this.types.line:
        return line.new(pointer, fillColour, strokeColour, strokeWidth)
      case this.types.arrow:
        return arrow.new(pointer, fillColour, strokeColour, strokeWidth)
      case this.types.rectangle:
        return rectangle.new(pointer, fillColour, strokeColour, strokeWidth)
      case this.types.ellipse:
        return ellipse.new(pointer, fillColour, strokeColour, strokeWidth)
      case this.types.triangle:
        return triangle.new(pointer, fillColour, strokeColour, strokeWidth)
    }
  },

  options: function (type, shape, pointer, shiftKey) {
    switch (type) {
      case this.types.line:
        return line.options(shape, pointer, shiftKey)
      case this.types.arrow:
        return arrow.options(shape, pointer, shiftKey)
      case this.types.rectangle:
        return rectangle.options(shape, pointer, shiftKey)
      case this.types.ellipse:
        return ellipse.options(shape, pointer, shiftKey)
      case this.types.triangle:
        return triangle.options(shape, pointer, shiftKey)
    }
  },

  visible: function (shape) {
    const minSize = 2 // triangles always seem to be at least 2 pixels
    return shape.width > minSize || shape.height > minSize
  },

  supportsText: function (shape) {
    return rectangle.isA(shape) || ellipse.isA(shape) || triangle.isA(shape)
  },

  addText: function (shape, settings) {
    return withText.new(shape, settings)
  },

  preserveStrokeWidth: function (shape) {
    const avgScale = (shape.scaleX + shape.scaleY) / 2

    if (withText.isA(shape)) {
      shape = withText.getShape(shape)
    }

    if (!shape._strokeWidth) {
      shape._strokeWidth = shape.strokeWidth
    }

    const strokeWidth = shape._strokeWidth / avgScale

    shape.set({ strokeWidth })
  },

  scale: function (shape) {
    const baseShape = withText.isA(shape) ? withText.getShape(shape) : shape
    if (baseShape._strokeWidth) {
      baseShape.strokeWidth = baseShape._strokeWidth
      baseShape._strokeWidth = null
    }

    if (line.isA(shape)) {
      return line.scale(shape)
    }

    if (rectangle.isA(shape)) {
      return rectangle.scale(shape)
    }

    if (triangle.isA(shape)) {
      return triangle.scale(shape)
    }

    if (ellipse.isA(shape)) {
      return ellipse.scale(shape)
    }

    if (arrow.isA(shape)) {
      return arrow.scale(shape)
    }

    if (withText.isA(shape)) {
      return withText.scale(shape)
    }

    if (path.isA(shape)) {
      return path.scale(shape)
    }
  },

  controlSettings: function (shape) {
    if (line.isA(shape)) {
      return line.controlSettings()
    }

    if (arrow.isA(shape)) {
      return arrow.controlSettings()
    }
  },

  configureControls: function (shape) {
    const settings = this.controlSettings(shape)
    if (settings) {
      shape.set(settings)
    }
  }
}
